import { FormSnack } from '../../../components/form/FormSnack'
import { FieldSnack } from '../../../components/form/FormSnack/validationSchema'
import { SubmitHandler } from 'react-hook-form'
import { SnackDataType } from '../../../interfaces/SnackData'

export default function CadastrarSnack() {
  const submit: SubmitHandler<FieldSnack> = (data: SnackDataType) => console.log(data)
  return <FormSnack submit={submit} />
}
